export var DateTimeMatchType;
(function (DateTimeMatchType) {
    DateTimeMatchType[DateTimeMatchType["Equals"] = 0] = "Equals";
    DateTimeMatchType[DateTimeMatchType["DoesNotEqual"] = 1] = "DoesNotEqual";
    DateTimeMatchType[DateTimeMatchType["IsNotEmpty"] = 2] = "IsNotEmpty";
    DateTimeMatchType[DateTimeMatchType["IsEmpty"] = 3] = "IsEmpty";
    DateTimeMatchType[DateTimeMatchType["GreaterThanOrEqualTo"] = 4] = "GreaterThanOrEqualTo";
    DateTimeMatchType[DateTimeMatchType["LessThanOrEqualTo"] = 5] = "LessThanOrEqualTo";
    DateTimeMatchType[DateTimeMatchType["GreaterThan"] = 6] = "GreaterThan";
    DateTimeMatchType[DateTimeMatchType["LessThan"] = 7] = "LessThan";
})(DateTimeMatchType || (DateTimeMatchType = {}));
;
